/* eslint-disable */
import React, {useCallback, useEffect, useRef, useState} from 'react';
import {useTranslation} from "react-i18next";
import {schema} from "@/features/user/register/stepFour/validations";
// adding basic request axios object
import {registerUserStepFour, registerUserStepFourData} from '@/apis/register/stepFour';
// toasting for messages
import {toastError, toastSuccess} from '@/helpers/toast';
// working with json promises
import {convertJSONToString, errorMessageFromServer} from '@/utils/server';
// reading axios response
import {AxiosResponse} from 'axios';
// helpers to concat select data
import {transformCatalog, concatSelectData} from '@/helpers/generic-transformer';
// lodash get to execute promise
import lGet from 'lodash/get';
import {makeRequired, makeValidate, SelectData} from "mui-rff";
import {makeYupTranslatedError} from "@/helpers/yup";
import {TStepFourForm} from "@/features/user/register/stepFour/types";
import StepFourForm from "@/features/user/register/stepFour/components/form";
import {MenuItem} from "@mui/material";
import {useHistory} from "react-router-dom";
import {useDispatch} from "react-redux";
import {setBackdrop} from "@/store/slices/appSlice";
import {checkErrorResponse} from "@/helpers/axios";

const StepFour = ({isModal, closePopover, stepperCallback, from = "Route"}: any): any => {
    //console.log("@StepFour loading component from ", from);

    const [t] = useTranslation();

    const [loading, setLoading] = useState(true);

    // to know if modal is open
    const [modalOpen, setModalOpen] = useState(false);

    const [submitting, setSubmitting] = useState(false);

    const initialValues: any = {
        cat_vat_taxes_id: 1,
        cat_vat_rates_id: 1,
        r_isr: 0,
        id: 0,
        ieps: null,
    };
    const initialValuesRef = useRef<any>(initialValues);

	const selectDataIVA: SelectData[] = [{label: t('step_four.helper_tax_regime'), value: 0, disabled: true}];
	const selectDataIVARef = useRef<SelectData[]>(selectDataIVA);
	const selectDataIVAWithHolding: SelectData[] = [{label: t('step_four.helper_tax_rate'), value: 0, disabled: true}];
	const selectDataIVAWithHoldingRef = useRef<SelectData[]>(selectDataIVAWithHolding);

    const selectDataISRWithHolding: SelectData[] = [
        {label: t('common.no'), value: 0},
        {label: t('common.yes'), value: 10},
    ];

    const validateForm = makeValidate(schema, makeYupTranslatedError);

    const required = makeRequired(schema);

    const getData = useCallback(async () => {
        // set loader
        setLoading(true);

		// call user data promise
		const promiseUserData = registerUserStepFourData();

		try {
			// promise all
			const results = await Promise.all<Promise<AxiosResponse>>([promiseUserData]);

			// set initial values
			const user_tax_data = results[0].data.user_taxes_data;
			initialValuesRef.current = {
                ...initialValuesRef.current, 
                ...user_tax_data,
                cat_vat_taxes_id: user_tax_data.cat_vat_taxes_id !== "" ? user_tax_data.cat_vat_taxes_id : initialValues.cat_vat_taxes_id,
                cat_vat_rates_id: user_tax_data.cat_vat_rates_id !== "" ? user_tax_data.cat_vat_rates_id : initialValues.cat_vat_taxes_id,
                r_isr: user_tax_data.r_isr !== "" ? user_tax_data.r_isr : initialValues.r_isr,
            };

			// set catalog
			const taxvat_select_data: SelectData[] = transformCatalog(results[0].data.tax_vat, 'name', 'id');
			selectDataIVARef.current = concatSelectData(selectDataIVARef.current, taxvat_select_data);

			// set catalog
			const taxvatrates_select_data: SelectData[] = transformCatalog(results[0].data.tax_vat_rates, 'name', 'id');
			selectDataIVAWithHoldingRef.current = concatSelectData(selectDataIVAWithHoldingRef.current, taxvatrates_select_data);

		} catch (e) {
            checkErrorResponse(e);
		} finally {
			// stop loading
			setLoading(false);
		}

    }, []);

    const history = useHistory();
    const dispatch = useDispatch();
    // yes, this can even be async!
    const onSubmit = async (values: any) => {
        setSubmitting(true);
        //console.log('values', values);
		try {
			const response = await registerUserStepFour(values);
            toastSuccess(response.data.message, {
                onOpen: () => (isModal) && dispatch(setBackdrop(true)),
                onClose: () => (isModal) && history.go(0)
            });
            // sense changes in complete register            
            if (!isModal && stepperCallback) {
                stepperCallback();
            }
			return true;
		} catch (error) {
			if (lGet(error, 'data')) {
				const errors = error.data.errors;
				const message = errorMessageFromServer(convertJSONToString(errors));
				toastError(message);
			} else {
				console.error('error: ', error);
                checkErrorResponse(error);
			}
			return false;
		} finally {
			setSubmitting(false);
		}
    };

    useEffect(() => {
        if (!isModal)
            getData().catch((e) => console.error(e));
    }, []);

    useEffect(() => {
        //console.log("@StepFour sensing value modalOpen: ", modalOpen);
        if (modalOpen) {
            //console.log("@StepFour modal is open and not loaded data first time");
            getData().catch((e: any) => console.error(e));
        }
    }, [modalOpen])

    const formProps: TStepFourForm = {
        onSubmit,
        initialValues: initialValuesRef.current,
        validateForm,
        required,
        submitting,
        selectDataIVA:selectDataIVARef.current,
        selectDataIVAWithHolding:selectDataIVAWithHoldingRef.current,
        selectDataISRWithHolding,
        isModal,
        closePopover,
        setModalOpen,
        loading
    }

    return (
        <>
            {<StepFourForm {...formProps} />}

            {/*{(loading && !isModal) && <>{t('common.loading')}</>}

            {(loading && isModal) && <MenuItem>{t('step_four.title')}</MenuItem>}*/}
        </>
    );
}

export default StepFour;
